import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
// import { postData } from "../../../backend/api";
import AutoForm from "../../elements/form";
import Footer from "../footer/index2";
import { FormContainer, MainContainer } from "./styles";
//using translation
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import withLayout from "../layout";
import { ColumnContainer } from "../../styles/containers/styles";
import Header from "../header";
import { clearLogin } from "../../../store/actions/login";
import { postData } from "../../../backend/api";
import { SignUpLink } from "../login/styles";
import LanguageTooltip from "../../elements/tooltip";
import { Logo, LogoDiv, Overlay, Page } from "../../elements/form/styles";
import { logo } from "../../../images";
import AccountTypeSelector from "./accontSelect";

const LoginPageLink = ()=>{
  const { t } = useTranslation();
  return(
    <SignUpLink>
      {t('Already have an account?')} <Link style={{color:'#15629A'}} to="/">{t('Log in')}</Link>
    </SignUpLink>
  )
}

const Registration = (props) => {
  useEffect(() => {
    document.title = `${t("registration")} - Whistleblowing24`;
  }, []);

  const [activeStep, setActiveStep] = useState(1);
  const [accountType, setAccountType] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login);
  const { t } = useTranslation();
  const { setLoaderBox } = props;
  useEffect(() => {
    if (user.data?.token) {
      navigate("/dashboard");
    }
    // setLoaderBox(user.isLoading);
    if (user.error !== null) {
      props.setMessage({ type: 1, content: t(user.error), proceed: "Okay", code: 400 });
      dispatch(clearLogin());
    }
  }, [user, navigate, setLoaderBox, t, props, dispatch]);

  const [formInput1] = useState([
    {
      type: "select",
      placeholder: "select",
      name: "totalEmployees",
      validation: "",
      default: "",
      label: "howManyEmployees",
      required: true,
      view: true,
      tag: true,
      add: true,
      update: true,
      apiType: "JSON",
      selectApi: [
        { id: "0 - 15", value: t("0 - 15") },
        { id: "15 - 30", value: t("15 - 30") },
        { id: "30 - 100", value: t("30 - 100") },
        { id: "100 - 500", value: t("100 - 500") },
        { id: "500 - 1000", value: t("500 - 1000") },
        { id: "1000+", value: t("1000+") },
      ],
      filter: false,
    },
    {
      type: "text",
      placeholder: "businessEmail",
      name: "email",
      validation: "email",
      default: "",
      label: "businessEmail",
      required: true,
      view: true,
      add: true,
      update: true,
    },
  ])

  const [formInput2, setFormInput2] = useState([
    {
      type: "text",
      placeholder: "Company name",
      name: "companyName",
      validation: "",
      default: "",
      label: "Company name",
      required: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "Company type",
      name: "industry",
      validation: "",
      default: "",
      label: "Company type",
      required: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "firstName",
      required: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "lastName",
      name: "lastName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "lastName",
      required: true,
      view: false,
      add: true,
      update: true,
    },
    // {
    //   type: "select",
    //   placeholder: "Your position",
    //   name: "position",
    //   validation: "",
    //   default: "",
    //   label: "Your position",
    //   required: true,
    //   view: true,
    //   add: true,
    //   update: true,
    //   customClass: "full",
    //   apiType: "JSON",
    //   selectApi: [
    //     { id: "CEO", value: t("CEO (Chief Executive Officer)") },
    //     { id: "HR Manager", value: t("HR Manager") },
    //     { id: "Admin/Operations Manager", value: t("Admin/Operations Manager") },
    //     { id: "Finance Manager/Accountant", value: t("Finance Manager/Accountant") },
    //     { id: "Department Manager", value: t("Department Manager") }
    //   ],
    //   filter: false,
    // },
    // {
    //   type: "text",
    //   placeholder: "Company website",
    //   name: "companyWebsite",
    //   validation: "",
    //   default: "",
    //   label: "Company website",
    //   required: false,
    //   view: false,
    //   add: true,
    //   update: true,
    //   customClass: "full",
    // },
    // {
    //   type: "select",
    //   placeholder: "Industry",
    //   name: "industry",
    //   validation: "",
    //   default: "",
    //   label: "Industry",
    //   required: true,
    //   view: true,
    //   add: true,
    //   update: true,
    //   customClass: "full",
    //   apiType: "JSON",
    //   selectApi: [
    //     { id: "IT & Software Industry", value: t("IT & Software Industry") },
    //     { id: "Manufacturing Industry", value: t("Manufacturing Industry") },
    //     { id: "Retail & E-commerce Industry", value: t("Retail & E-commerce Industry") },
    //     { id: "Healthcare Industry", value: t("Healthcare Industry") },
    //     { id: "Hospitality Industry (Hotels & Restaurants)", value: t("Hospitality Industry (Hotels & Restaurants)") }
    //   ],
    //   filter: false,
    // },
    {
      type: "text",
      placeholder: "telephone",
      name: "mobileNumber",
      validation: "mobile",
      default: "",
      label: "telephone",
      required: false,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "businessEmail",
      name: "email",
      validation: "email",
      default: "",
      label: "businessEmail",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      placeholder: "select",
      name: "totalEmployees",
      validation: "",
      default: "",
      label: "howManyEmployees",
      required: true,
      view: true,
      tag: true,
      add: true,
      update: true,
      apiType: "JSON",
      selectApi: [
        { id: "0 - 15", value: t("0 - 15") },
        { id: "15 - 30", value: t("15 - 30") },
        { id: "30 - 100", value: t("30 - 100") },
        { id: "100 - 500", value: t("100 - 500") },
        { id: "500 - 1000", value: t("500 - 1000") },
        { id: "1000+", value: t("1000+") },
      ],
      filter: false,
      customClass: "full",
    },
    {
      type: "checkbox",
      placeholder: "acceptSignupSubmit",
      name: "acceptSignupSubmit",
      validation: "",
      showItem: "",
      default: "",
      label: "acceptSignupSubmit",
      required: true,
      view: false,
      tag: true,
      add: false,
      update: false,
    },
    
  ]);

  const [formData, setFormData] = useState({});

  const isCreatingHandler = (value, callback) => {};
  const submitChange = async (post) => {
    let payload = {...post, ...formData};
    delete payload.acceptSignupSubmit;
    //call set password with
    props.setLoaderBox(true);
    await postData({ ...payload }, accountType + "/signup")
      .then((response) => {
        if (response.status === 200) {
          props.setMessage({
            type: 1,
            content: t("enquiryFill"),
            okay: "Login",
            onClose: () => {
              navigate("/");
            },
            code: 200,
          });
          props.setLoaderBox(false);
        } else if (response.status === 201) {
          props.setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 201 });
          props.setLoaderBox(false);
        } else {
          props.setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
          props.setLoaderBox(false);
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        props.setMessage({ type: 1, content: t(error.message) + t("somethingWrong"), proceed: "Okay", code: 500 });
        setLoaderBox(false);
      });
  };

  return (
    <MainContainer>
      <Header></Header>
      <ColumnContainer className="login signup">
        <FormContainer>
          {
          // activeStep===1 ? <AutoForm key={"form"} useCaptcha={false} formType={"post"} description={t("signupdesc")} header={t("signup")} formInput={formInput1} submitHandler={(post)=> {
          //   setFormData(post)
          //   setActiveStep(2)
          //   }} button={t("next")} isOpenHandler={isCreatingHandler} isOpen={true} plainForm={true} login={"signupForm"} isLanguage={true} page={"login"}></AutoForm>
          // : 
          activeStep===1 ? <Overlay className={` signupForm double  plain `}>
                <Page className={`signupForm plain`}>
                  {/* when the props have the value of header then form will add the header as props.header*/}
                  {/* {(props.logo && props.header) ? <Header className={props.plainForm ? "plain" : "popup"}>{props.header} </Header> : ""} */}
                  {/* {props.description && <Description dangerouslySetInnerHTML={{ __html: props.description }} />} */}
                  {/* <LogoDiv className="signupForm">
                    <Logo className="signupForm" src={logo} alt="logo" />
                  </LogoDiv> */}
                  <div style={{ position: "absolute", top: "0px", right: "10px", zIndex: 1000 }}>
                    <LanguageTooltip page={"login"} />
                  </div>
                  <AccountTypeSelector t={t} accountType={accountType} onSelect={(type) => {
                    setAccountType(type)
                    // if(type==="partner"){
                    //   let updated = [...formInput2];
                    //   updated.splice(5, 1); // remove index 4 first
                    //   updated.splice(2, 1); // then remove index 2
                    //   setFormInput2(updated);
                    // }
                    
                  }} onNext={()=> setActiveStep(2)} />
                </Page>
              </Overlay>
          : <AutoForm key={"form"} useCaptcha={false} formType={"post"} description={t("signupdesc")} header={t("signup")} formInput={formInput2} submitHandler={submitChange} button={t("submit")} isOpenHandler={isCreatingHandler} isOpen={true} plainForm={true} login={"signupForm"} isLanguage={true} page={"login"}></AutoForm>}
          {/* <div style={{marginTop:'10px',width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <LanguageTooltip page={"login"} />
          </div> */}
          <SignUpLink>
            {t('Already have an account?')} <Link style={{color:'#15629A'}} to="/">{t('Log in')}</Link>
          </SignUpLink>
        </FormContainer>
      </ColumnContainer>
      {/* <Footer></Footer> */}
    </MainContainer>
  );
};

export default withLayout(Registration);
